import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './Auth';
import './SignUp.css'; // Reuse the same CSS

const SignIn = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.email || !formData.password) {
            setError('Please enter both email and password');
            return;
        }
        
        setIsSubmitting(true);
        
        try {
            await signInWithEmailAndPassword(
                auth,
                formData.email,
                formData.password
            );
            
            // Redirect to user profile
            navigate('/being');
        } catch (error) {
            console.error('Error during sign in:', error);
            
            // Provide user-friendly error messages
            if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
                setError('Invalid email or password');
            } else if (error.code === 'auth/too-many-requests') {
                setError('Too many failed login attempts. Please try again later');
            } else {
                setError(error.message || 'Failed to sign in. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const goToSignUp = () => {
        navigate('/signup');
    };

    return (
        <div className="signup-container">
            <div className="signup-header">
                <h1 className="signup-title">Welcome Back</h1>
                <p className="signup-tagline">Continue your journey</p>
            </div>
            
            <div className="signup-content">
                <form className="signup-form" onSubmit={handleSubmit}>
                    <div className="form-section">
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                className="form-input-signup"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="your.email@example.com"
                            />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                className="form-input-signup"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Your password"
                            />
                        </div>
                    </div>
                    
                    {error && <p className="error-message submit-error">{error}</p>}
                    
                    <button type="submit" className="form-button" disabled={isSubmitting}>
                        {isSubmitting ? 'Signing in...' : 'Sign In'}
                    </button>

                    <div className="signin-link">
                        <p>
                            Forgot password? <button type="button" className="text-button">Reset Password</button>
                        </p>
                    </div>
                </form>
                
                <div className="signin-link">
                    <p>
                        Don't have an account yet? <button onClick={goToSignUp} className="text-button">Sign Up</button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SignIn;